export const CLIENT_STATUSES = [
  { id: 'ACTIVE', name: 'aktívny' },
  { id: 'INACTIVE', name: 'neaktívny' },
];
